import React, { useState, useEffect, useRef } from 'react'
import { FixedSizeList as List } from 'react-window'
import { replaceAccentedCharacters } from '../../helpers/utils'

export default function CheckboxDropdownList({
  users,
  options,
  onSelectionChange,
  disabled,
  occupiedUsersData
}) {
  const [isDropdownOpen, setDropdownOpen] = useState(false)
  const [selectedOptions, setSelectedOptions] = useState(new Set())
  const [selectAll, setSelectAll] = useState(false)
  const [search, setSearch] = useState('')
  const filterContainer = useRef(null)

  const MIN_ITEMS = 4
  const MAX_ITEMS = 8
  const ITEM_HEIGHT = 30
  const BASE_HEIGHT = 61

  const calculateMaxHeight = () => {
    const numberOfOptions = filteredOptions.length

    switch (true) {
      case numberOfOptions === 2:
        return 110
      case numberOfOptions === 1:
        return BASE_HEIGHT
      case numberOfOptions <= MIN_ITEMS:
      case numberOfOptions <= MAX_ITEMS:
        return BASE_HEIGHT + numberOfOptions * ITEM_HEIGHT
      default:
        return 260
    }
  }

  const searchWithoutAccentedCharacters = replaceAccentedCharacters(search)

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick)
    return () => document.removeEventListener('mousedown', handleOutsideClick)
  }, [])

  useEffect(() => {
    if (disabled) {
      setDropdownOpen(false)
    }
  }, [disabled])

  useEffect(() => {
    const usersInStateArray = users.map((u) => {
      return `${u.uid} - ${u.full_name}`
    })
    const usersInOptionMap = new Set(usersInStateArray)
    if (usersInOptionMap !== selectedOptions) {
      setSelectedOptions(usersInOptionMap)
    }
  }, [users])

  const handleOutsideClick = (e) => {
    if (filterContainer.current && !filterContainer.current.contains(e.target)) {
      setDropdownOpen(false)
    }
  }

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedOptions(new Set())
      onSelectionChange(new Set())
    } else {
      const newSelectedOptions = new Set(filteredOptionsWithoutOccupied)
      setSelectedOptions(newSelectedOptions)
      onSelectionChange(newSelectedOptions)
    }
    setSelectAll(!selectAll)
  }

  const filterOptions = () => {
    return options?.filter((option) => shouldDisplay(option))
  }
  const shouldDisplay = (option) => {
    if (search.length <= 0) return true
    return replaceAccentedCharacters(option).includes(searchWithoutAccentedCharacters)
  }

  const isOccupied = (option) => {
    return occupiedUsersData[option]
  }

  const selectOption = (option) => {
    if (disabled) return
    const newSelectedOptions = new Set(selectedOptions)
    if (newSelectedOptions.has(option)) {
      newSelectedOptions.delete(option)
    } else {
      newSelectedOptions.add(option)
    }
    setSelectedOptions(newSelectedOptions)

    onSelectionChange(newSelectedOptions)
  }

  const handleFilterSearch = (e) => {
    if (disabled) return
    setSearch(e.target.value)
    setSelectAll(false)
  }

  const filteredOptions = options.filter(
    (option) =>
      option != null &&
      replaceAccentedCharacters(option.toString()).includes(searchWithoutAccentedCharacters)
  )

  const filteredOptionsWithoutOccupied = options.filter(
    (option) =>
      option != null &&
      !isOccupied(option) &&
      replaceAccentedCharacters(option.toString()).includes(searchWithoutAccentedCharacters)
  )

  const Row = ({ index, style }) => {
    const option = filteredOptions[index]
    const occupiedUser = isOccupied(option)
    return (
      <div
        style={style}
        className="react-filter-option"
        onClick={() => (!occupiedUser ? selectOption(option) : '')}
      >
        <input
          type="checkbox"
          className={`filter-checkbox${occupiedUser ? '-disabled' : ''}`}
          readOnly
          checked={selectedOptions.has(option) || occupiedUser}
          disabled={disabled || occupiedUser}
        />
        <div className={`dropdown-checkbox-label${occupiedUser ? '-disabled' : ''}`}>
          {option}
          {occupiedUser ? ` -  ASIGNADO A: ${occupiedUser}` : ''}
        </div>
      </div>
    )
  }

  return (
    <div
      className={`checkbox-dropdown-input-box ${disabled ? 'react-filter-disabled' : ''}`}
      ref={filterContainer}
    >
      <div
        onClick={() => !disabled && setDropdownOpen(!isDropdownOpen)}
        className="react-filter-box-clickable-zone"
      >
        <input
          type="search"
          className="checkbox-dropdown-search-input"
          placeholder="Buscar usuario(s) por nombre o código"
          value={search}
          onChange={handleFilterSearch}
          disabled={disabled}
        />
        {search && <div onClick={() => setSearch('')} className="filter-search-input-x"></div>}
      </div>
      {isDropdownOpen && (
        <div
          className="checkbox-list-dropdown-box box-transition"
          style={{
            maxHeight: `${calculateMaxHeight()}px`
          }}
        >
          <div className="filter-search-input-container">
            <div className="react-filter-dropdown-box-items">
              {filteredOptions.length <= 50 && !search && (
                <div className="react-filter-option" onClick={toggleSelectAll}>
                  <input type="checkbox" className="filter-checkbox" readOnly checked={selectAll} />
                  <div className="dropdown-checkbox-label mt-10 ml--10">
                    {selectAll
                      ? 'Deseleccionar todos los usuarios activos'
                      : 'Seleccionar todos los usuarios activos'}
                  </div>
                </div>
              )}

              {filterOptions()?.length == 0 && search && (
                <div className="react-filter-option">
                  <div className="dropdown-checkbox-label mt-10 ml--10 ">No hubo resultados</div>
                </div>
              )}
            </div>
          </div>
          <List height={300} itemCount={filteredOptions.length} itemSize={35} width="100%">
            {Row}
          </List>
        </div>
      )}
    </div>
  )
}
